module.exports = __webpack_public_path__ + "static/media/loader-dailymail.fa9571fa.gif";